import React from "react";

/**
 * INFRA wordmark — stylized SVG approximation of the Grupo INFRA brand identity.
 * The user (CIMA, authorized distributor) should replace this with the official
 * INFRA logo PNG when provided, by setting INFRA_LOGO_URL below.
 *
 * To swap to the official PNG:
 *   1. Upload the official INFRA logo to /app/frontend/public/infra-logo.png
 *   2. Or set INFRA_LOGO_URL to the hosted URL.
 *   3. The <InfraLogo /> component will render the image instead of the SVG.
 */
const INFRA_LOGO_URL = "/infra-logo.png"; // background ya removido, sobre blanco

const INFRA_RED = "#E30613";
const INFRA_ORANGE = "#F39200";

export default function InfraLogo({ className = "", height = 56 }) {
  if (INFRA_LOGO_URL) {
    return (
      <span
        className={`inline-flex items-center justify-center bg-white ${className}`}
        style={{ height, padding: "4px 10px" }}
      >
        <img
          src={INFRA_LOGO_URL}
          alt="INFRA"
          style={{ height: Math.max(height - 8, 16) }}
          className="w-auto object-contain"
        />
      </span>
    );
  }

  // SVG fallback — faithful brand approximation
  return (
    <svg
      viewBox="0 0 280 100"
      className={className}
      style={{ height }}
      role="img"
      aria-label="INFRA"
    >
      {/* Flame accent above the I (INFRA's signature spark) */}
      <g transform="translate(18, 6)">
        <path
          d="M0 24 C 0 16, 6 10, 12 0 C 14 8, 18 12, 18 18 C 18 24, 14 28, 9 28 C 4 28, 0 26, 0 24 Z"
          fill={INFRA_ORANGE}
        />
        <path
          d="M4 22 C 4 18, 8 14, 12 8 C 13 12, 15 16, 15 20 C 15 24, 12 26, 9 26 C 6 26, 4 24, 4 22 Z"
          fill={INFRA_RED}
        />
      </g>

      {/* INFRA wordmark */}
      <text
        x="0"
        y="84"
        fontFamily="'Outfit', 'Arial Black', sans-serif"
        fontWeight="900"
        fontSize="78"
        letterSpacing="-3"
        fill={INFRA_RED}
      >
        INFRA
      </text>

      {/* Underline accent */}
      <rect x="0" y="92" width="220" height="3" fill={INFRA_ORANGE} />
    </svg>
  );
}
